module.exports = __webpack_public_path__ + "static/media/mern.155b42c9.jpg";